import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'
import { getOldWorkflowRedirect } from '../helper'

export default async function loader() {
  const oldWorkflowRedirect = getOldWorkflowRedirect(
    '/stock/purchaseorder/active'
  )
  if (oldWorkflowRedirect) return oldWorkflowRedirect

  logger.debug(
    '[loader] About to await AppState being ready in Outstanding Orders loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Outstanding Orders loader'
  )

  // Populating the stock take templates dropdown before the page loads
  const outstandingOrdersPromise = useStockStore
    .getState()
    .getOutstandingPurchaseOrders()
  const suppliers = useStockStore.getState().getSuppliers()
  const items = useStockStore.getState().getItems()
  const brands = useStockStore.getState().getBrands()
  const units = useStockStore.getState().getStockUnits()

  // Return a deferred promise to enable React Router's built-in loading state
  // This approach is currently required for compatibility with our PageLoadingSupport.tsx logic,
  // even though defer() is considered legacy in newer React Router versions.
  return defer({
    data: Promise.all([
      outstandingOrdersPromise,
      suppliers,
      items,
      brands,
      units,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Outstanding Orders error: ', error)
        return false
      }),
  })
}
